import React from "react";
import { useSite } from "../context/SiteContext";
import { useI18n } from "../i18n/I18nContext";

export default function Logo({ light = false, compact = false }) {
    const { site } = useSite();
    const { lang } = useI18n();
    const primary = light ? "#FFFFFF" : "#0A0A0A";
    const gold = "#EFAA1E";

    const identity = site?.identity || {};
    const name = identity[lang === "en" ? "name_en" : "name_fr"] || identity.name_fr || "GAB'S SERVICES";
    const sub = identity[lang === "en" ? "sub_en" : "sub_fr"] || identity.sub_fr || "SARL MALI";
    const logoUrl = identity.logo_url || "";
    const size = compact ? 36 : 46;

    return (
        <div className="flex items-center gap-3" data-testid="brand-logo">
            {logoUrl ? (
                <img
                    src={logoUrl}
                    alt={name}
                    style={{ width: size, height: size, objectFit: "contain" }}
                    data-testid="brand-logo-image"
                />
            ) : (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 64 48"
                    fill="none"
                    aria-hidden="true"
                >
                    {/* Black roof outline */}
                    <path
                        d="M6 30 L26 12 L34 20 L42 12 L58 30"
                        stroke={primary}
                        strokeWidth="4"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        fill="none"
                    />
                    {/* Gold inner accent */}
                    <path
                        d="M12 32 L26 18 L34 26 L42 18 L54 32"
                        stroke={gold}
                        strokeWidth="3"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        fill="none"
                    />
                    {/* Chimney */}
                    <rect x="44" y="12" width="4" height="8" fill={primary} />
                    {/* Little window */}
                    <rect x="29" y="30" width="6" height="6" fill={primary} />
                    <line x1="32" y1="30" x2="32" y2="36" stroke={gold} strokeWidth="1" />
                    <line x1="29" y1="33" x2="35" y2="33" stroke={gold} strokeWidth="1" />
                </svg>
            )}
            <div className="leading-tight">
                <div
                    className="font-display font-bold text-[1.05rem] tracking-tight"
                    style={{ color: primary }}
                    data-testid="brand-name"
                >
                    {name}
                </div>
                <div
                    className="text-[0.62rem] tracking-[0.25em] font-bold"
                    style={{ color: gold }}
                    data-testid="brand-sub"
                >
                    {sub}
                </div>
            </div>
        </div>
    );
}
